/* Elif Transfer — Beden-Adet Matrisi (tekstil urunleri)
 * Renk secici + her beden icin adet kutusu. Iki aksiyon:
 *  - Sepete Ekle  -> /cart/add.js (cok satir, standart sepet)
 *  - Teklif Sepetine Ekle -> window.TeklifCart (localStorage teklif sepeti)
 * Blok: blocks/teklif-matrix.liquid
 */
(function () {
  'use strict';

  /* Türkçe renk adı -> hex (aktif renk konturu için) */
  var SW_KW = {
    'siyah': '#1a1a1a', 'beyaz': '#e9e9e9', 'lacivert': '#1c2a4a', 'sax': '#5a86b8',
    'turkuaz': '#16b8c6', 'benetton': '#0a7a5a', 'haki': '#7c7b46', 'narçiçeği': '#f0533f',
    'fuşya': '#e5007e', 'füme': '#45494f', 'antrasit': '#33373b', 'indigo': '#3a4a86',
    'mint': '#8fe0bd', 'bordo': '#7a1f2b', 'krem': '#efe7d3', 'bej': '#d9c8a5',
    'kahve': '#5a3a22', 'pembe': '#f2a3bd', 'mor': '#7b3fa0', 'turuncu': '#f26a21',
    'kırmızı': '#d81e2c', 'sarı': '#f4c400', 'yeşil': '#2e9b4f', 'mavi': '#2f6fd0', 'gri': '#9a9a9a'
  };
  var SW_ORDER = ['siyah', 'beyaz', 'lacivert', 'sax', 'turkuaz', 'benetton', 'haki', 'narçiçeği',
    'fuşya', 'füme', 'antrasit', 'indigo', 'mint', 'bordo', 'krem', 'bej', 'kahve', 'pembe',
    'mor', 'turuncu', 'kırmızı', 'sarı', 'yeşil', 'mavi', 'gri'];
  function _shade(hex, p) {
    var c = hex.replace('#', '');
    function a(v) { v = p > 0 ? v + (255 - v) * p : v * (1 + p); return ('0' + Math.max(0, Math.min(255, Math.round(v))).toString(16)).slice(-2); }
    return '#' + a(parseInt(c.substr(0, 2), 16)) + a(parseInt(c.substr(2, 2), 16)) + a(parseInt(c.substr(4, 2), 16));
  }
  function _lum(hex) {
    var c = hex.replace('#', '');
    return (0.299 * parseInt(c.substr(0, 2), 16) + 0.587 * parseInt(c.substr(2, 2), 16) + 0.114 * parseInt(c.substr(4, 2), 16)) / 255;
  }
  function swatchColor(name) {
    var n = (name || '').toLowerCase().trim(), base = null, i;
    for (i = 0; i < SW_ORDER.length; i++) { if (n.indexOf(SW_ORDER[i]) >= 0) { base = SW_KW[SW_ORDER[i]]; break; } }
    if (!base) return null;
    if (n.indexOf('açık') >= 0 || n.indexOf('acık') >= 0) base = _shade(base, 0.3);
    else if (n.indexOf('koyu') >= 0) base = _shade(base, -0.32);
    if (_lum(base) > 0.82) base = _shade(base, -0.22);
    return base;
  }

  /* Renk butonundaki mini tisort ikonu */
  var TEE_D = 'M8.6 3 5 4.7 3.4 8.6l2.4 1.1.9-2.1V21h10.6V7.6l.9 2.1 2.4-1.1L19 4.7 15.4 3a3.5 3.5 0 0 1-6.8 0Z';
  var SVG_NS = 'http://www.w3.org/2000/svg';
  function teeIcon() {
    var svg = document.createElementNS(SVG_NS, 'svg');
    svg.setAttribute('viewBox', '0 0 24 24');
    svg.setAttribute('aria-hidden', 'true');
    svg.setAttribute('class', 'tmatrix__tee');
    var p = document.createElementNS(SVG_NS, 'path');
    p.setAttribute('d', TEE_D);
    svg.appendChild(p);
    return svg;
  }

  /* Secilen rengin gorseline urun galerisini gecirir.
   *
   * NEDEN BOYLE: Horizon'un <media-gallery>'si SADECE secili varyantin medyasini basar
   * (urunde 22 renk gorseli olsa bile DOM'da 1-2 medya bulunur). Bu yuzden "slayti bul ve
   * secc" yaklasimi calismaz. Horizon'un kendi varyant guncellemesi de galeriyi sunucudan
   * yeniden render edip replaceWith ile degistirir — burada ayni sey yapiliyor:
   * bolumun HTML'i ?variant=ID ile cekilir, icindeki media-gallery mevcut olanla degistirilir.
   *
   * Sadece ilgili bolum cekilir (section_id), tum sayfa degil. Hizli renk tiklamalarinda
   * onceki istek iptal edilir. Hata durumunda sessizce cikar, sayfayi bozmaz. */
  /* Yanlis renk karesini gizle: dogru gorsel gelene kadar galeriyi soluklastir.
   * (5/10 Adet varyantlarinda gorsel olmadigi icin tema araya urunun VARSAYILAN
   * fotografini koyuyor ve renk gecisinde yanlis renk bir an gorunuyordu.) */
  function galleryBusy(on) {
    var g = document.querySelector('media-gallery');
    var host = g && g.parentElement;
    if (host) host.classList.toggle('et-gal-busy', !!on);
  }

  var galAbort = null;
  var galCache = {};   /* renk -> <media-gallery> outerHTML (bir kez cekilir) */

  function applyGalleryHTML(html) {
    if (!html || typeof window.DOMParser !== 'function') return false;
    var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('media-gallery');
    var now = document.querySelector('media-gallery');
    if (fresh && now && now.parentNode) { now.replaceWith(fresh); return true; }
    return false;
  }

  /* Bolumun HTML'ini ?variant=ID ile ceker, icindeki <media-gallery>'yi geri verir.
   * GUVENLIK: donen HTML'den SADECE galeri kullanilir; formdaki secili varyant,
   * fiyat ve <input name="id"> hic degistirilmez. */
  function fetchGalleryFor(variantId, productUrl, cb) {
    var cur = document.querySelector('media-gallery');
    if (!cur || typeof window.fetch !== 'function' || typeof window.DOMParser !== 'function') return cb(null);
    var sec = cur.closest ? cur.closest('.shopify-section') : null;
    var sid = (sec && sec.id) ? sec.id.replace('shopify-section-', '') : '';
    var url = productUrl + (productUrl.indexOf('?') >= 0 ? '&' : '?') +
              'variant=' + encodeURIComponent(variantId) +
              (sid ? '&section_id=' + encodeURIComponent(sid) : '');
    try { if (galAbort) galAbort.abort(); } catch (e) {}
    galAbort = (typeof AbortController === 'function') ? new AbortController() : null;
    fetch(url, galAbort ? { signal: galAbort.signal } : undefined)
      .then(function (r) { return r.ok ? r.text() : Promise.reject(new Error('http')); })
      .then(function (t) {
        var g = new DOMParser().parseFromString(t, 'text/html').querySelector('media-gallery');
        cb(g ? g.outerHTML : null);
      })
      .catch(function (err) { if (!err || err.name !== 'AbortError') cb(null); });
  }

  /* ── Native varyant secicideki RENK secenegini bizim tasarimla giydir ──
   * Horizon yapisi: <variant-picker> > fieldset[data-option-id] > label.variant-option__button-label > input[radio]
   * Her butona rengin kendi tonunu (--sw) ve mini tisort ikonunu ekler.
   * Boylece renk secimi TEK yerde kalir; matris kendi renk satirini gizler. */
  function nativeColorFieldset() {
    var list = document.querySelectorAll('variant-picker fieldset[data-option-id]');
    for (var i = 0; i < list.length; i++) {
      var id = (list[i].getAttribute('data-option-id') || '').toLowerCase();
      var lg = list[i].querySelector('legend');
      var t = ((lg && lg.textContent) || '').toLowerCase();
      if (id.indexOf('renk') >= 0 || id.indexOf('color') >= 0 || t.indexOf('renk') >= 0 || t.indexOf('color') >= 0) return list[i];
    }
    return null;
  }

  /* TUM secenekler (Adet/Renk/Beden) kompakt matris stiline gecer.
   * Renk secenegine ayrica rengin kendi tonu (--sw) + mini tisort ikonu eklenir. */
  function decorateNativeColors(colorFs) {
    var vp = document.querySelector('variant-picker');
    if (!vp) return;
    var fss = vp.querySelectorAll('fieldset[data-option-id]');
    for (var i = 0; i < fss.length; i++) {
      var fs = fss[i];
      fs.classList.add('et-swfield');
      var labels = fs.querySelectorAll('.variant-option__button-label');
      for (var j = 0; j < labels.length; j++) {
        var l = labels[j];
        l.classList.add('et-swopt');
        if (fs !== colorFs || l.getAttribute('data-sw')) continue;
        var inp = l.querySelector('input[type="radio"]');
        if (!inp) continue;
        var sw = swatchColor(inp.value);
        if (sw) l.style.setProperty('--sw', sw);
        l.classList.add('et-swlabel');
        var txt = l.querySelector('.variant-option__button-label__text');
        /* Ikon LABEL'in dogrudan cocugu: label flex + align-items:center oldugu icin
         * dikey olarak kendiliginden ortalanir (metin span'inin icinde ust-sola kaciyordu). */
        if (txt && !l.querySelector('.tmatrix__tee')) l.insertBefore(teeIcon(), txt);
        l.setAttribute('data-sw', '1');
      }
    }
  }

  /* Bir rengin gorseli SADECE bazi adet kademelerine atanmis olabilir (ör. yalnizca
   * "1 Adet"). Bu fonksiyon o renge ait, gorseli OLAN herhangi bir varyanti bulur.
   *
   * GUVENLIK: Donen id yalnizca GALERIYI tazelemek icin kullanilir. Formdaki
   * <input name="id">, fiyat blogu ve secili varyant HIC DEGISTIRILMEZ — musteri
   * ne sectiyse o sepete gider. Sadece ekranda dogru renk fotografi gosterilir. */
  function imageVariantForColor(variants, colorIndex, color) {
    for (var i = 0; i < variants.length; i++) {
      var o = variants[i].o || [];
      if (colorIndex >= 0 && String(o[colorIndex]) !== String(color)) continue;
      if (variants[i].mid) return variants[i].id;
    }
    return 0;
  }

  function initAll() {
    var nodes = document.querySelectorAll('.tmatrix:not([data-init])');
    for (var i = 0; i < nodes.length; i++) init(nodes[i]);
    decorateNativeColors(nativeColorFieldset());
  }

  function init(root) {
    root.setAttribute('data-init', '1');

    var sizeIndex = parseInt(root.getAttribute('data-size-index'), 10);
    var colorIndex = parseInt(root.getAttribute('data-color-index'), 10);
    var sizes = (root.getAttribute('data-sizes') || '').split('|').filter(Boolean);
    var colors = (root.getAttribute('data-colors') || '').split('|').filter(Boolean);
    var cartBehavior = root.getAttribute('data-cart-behavior') || 'redirect';
    var product = {
      id: root.getAttribute('data-product-id') || '',
      title: root.getAttribute('data-product-title') || '',
      url: root.getAttribute('data-product-url') || ''
    };

    var variants = [];
    try { variants = JSON.parse(root.querySelector('.tmatrix-data').textContent); } catch (e) { variants = []; }

    var colorsWrap = root.querySelector('.tmatrix__colors');
    var colorNameEl = root.querySelector('.tmatrix__color-name');
    var grid = root.querySelector('.tmatrix__grid');
    var totalEl = root.querySelector('.tmatrix__total b');
    var msgEl = root.querySelector('.tmatrix__msg');
    var btnCart = root.querySelector('.tmatrix__btn--cart');
    var btnTeklif = root.querySelector('.tmatrix__btn--teklif');

    var selectedColor = colors.length ? colors[0] : null;

    var handledColor = null;

    /* Renk icin galeriyi yerlestir (iki yol da bunu kullanir: native secici ve matris).
     * - Onbellekte varsa ANINDA uygular (ag istegi yok, titreme yok)
     * - Yoksa bir kez ceker, onbellege alir, uygular
     * force=true: ayni renk olsa bile yeniden uygula (tema uzerine yazdiginda) */
    function swapForColor(col, force) {
      if (!col) return;
      if (galCache[col]) { applyGalleryHTML(galCache[col]); galleryBusy(false); handledColor = col; return; }
      if (!force && col === handledColor) return;
      handledColor = col;
      var vid = imageVariantForColor(variants, colorIndex, col);
      if (!vid) { galleryBusy(false); return; }
      galleryBusy(true);
      fetchGalleryFor(vid, product.url, function (html) {
        if (html) { galCache[col] = html; applyGalleryHTML(html); }
        galleryBusy(false);
      });
    }

    function findVariant(color, size) {
      for (var i = 0; i < variants.length; i++) {
        var o = variants[i].o || [];
        var sizeMatch = String(o[sizeIndex]) === String(size);
        var colorMatch = (colorIndex < 0) || (String(o[colorIndex]) === String(color));
        if (sizeMatch && colorMatch) return variants[i];
      }
      return null;
    }

    /* O renge ait varyant id'si — once stokta olani, yoksa ilk eslesen */
    function variantIdForColor(color) {
      var fallback = 0, i, o;
      for (i = 0; i < variants.length; i++) {
        o = variants[i].o || [];
        if ((colorIndex >= 0) && String(o[colorIndex]) !== String(color)) continue;
        if (!fallback) fallback = variants[i].id;
        if (variants[i].a) return variants[i].id;
      }
      return fallback;
    }

    /* ---------- Stok uyarisi ----------
     * Renk secilir secilmez, SECENEKLERIN HEMEN ALTINA tasinip bir kez gosterilir.
     * Bir kez: her tiklamada yeniden belirip kaybolmasi dikkat dagitici olurdu.
     * WhatsApp linkine urun adi + secili renk gomulur — musteri yazmak zorunda
     * kalmaz, biz de neyin soruldugunu aninda goruruz. */
    var stockNote = root.querySelector('.tmatrix__stock');
    var stockShown = false;

    /* Sag alttaki canli destek balonunu acar (Shopify Inbox).
     * Buton shadow DOM icinde oldugu icin oradan cekiliyor. */
    function canliDestekAc() {
      var host = document.querySelector('inbox-online-store-chat') ||
                 document.querySelector('shopify-chat') ||
                 document.querySelector('shopify-agent');
      if (!host) return false;
      var kok = host.shadowRoot || host;
      var btn = kok.querySelector('.chat-toggle, button');
      if (!btn) return false;
      btn.click();
      return true;
    }

    var askBtn = stockNote && stockNote.querySelector('[data-stock-ask]');
    if (askBtn) {
      askBtn.addEventListener('click', function () {
        /* Once canli destek. Eklenti yoksa yedek baglantiya dus. */
        if (canliDestekAc()) return;
        var yedek = askBtn.getAttribute('data-fallback');
        if (yedek) window.open(yedek, '_blank', 'noopener');
      });
      /* Ikisi de yoksa butonu hic gosterme — tiklayip hicbir sey olmamasindan iyi.
       * Sohbet eklentisi gec yuklenebildigi icin biraz bekleyip bakiyoruz. */
      setTimeout(function () {
        var sohbetVar = !!(document.querySelector('inbox-online-store-chat') ||
                           document.querySelector('shopify-chat') ||
                           document.querySelector('shopify-agent'));
        if (!sohbetVar && !askBtn.getAttribute('data-fallback')) askBtn.hidden = true;
      }, 2500);
    }

    function stockAsk() { /* metin artik baglantiya gomulmuyor; sohbet aciliyor */ }

    var stockAnchor = null;
    var stockTimer = null;
    var stockFadeTimer = null;
    var STOCK_MS = (parseInt(root.getAttribute('data-stock-seconds'), 10) || 30) * 1000;

    /* Notu renk seceneklerinin hemen altina yerlestirir.
     * YENIDEN YERLESTIRME SART: tema, renk degisince varyant secicinin DOM'unu
     * bastan basiyor. Not o alanin komsusu oldugu icin birlikte siliniyordu —
     * musteri okumaya firsat bulamadan kayboluyordu. Burada ayni DOM dugumunu
     * (referansi bizde duruyor) taze fieldset'in yanina geri takiyoruz. */
    function placeStockNote(anchor) {
      if (!stockNote) return;
      if (anchor && anchor.parentNode) stockAnchor = anchor;
      var a = stockAnchor;
      if (a && a.parentNode && stockNote.previousSibling !== a) {
        a.parentNode.insertBefore(stockNote, a.nextSibling);
      }
    }

    function showStockNote(anchor, color) {
      if (!stockNote) return;
      stockAsk(color);

      var gorunuyordu = stockShown && !stockNote.hidden;
      placeStockNote(anchor);
      stockShown = true;

      if (stockFadeTimer) { clearTimeout(stockFadeTimer); stockFadeTimer = null; }
      stockNote.hidden = false;

      /* hidden kalktiktan HEMEN sonra sinif eklenirse tarayici gecisi oynatmaz;
       * bir reflow zorlayarak baslangic durumunu sabitliyoruz.
       * NOT: burada once requestAnimationFrame vardi. Arka plan sekmelerinde ve
       * bazi gomulu tarayicilarda rAF hic tetiklenmiyor — o durumda not yer
       * kapliyor ama opaklik 0'da takili kaliyordu (goze gorunmuyordu).
       * Reflow senkron oldugu icin her ortamda calisir.
       * Zaten ekrandaysa reflow'a gerek yok: animasyonu bastan oynatmak titretir. */
      if (!gorunuyordu) void stockNote.offsetHeight;
      stockNote.classList.add('is-in');

      /* Her renk seciminde sure bastan baslar; 0 = hic gizlenmesin */
      if (stockTimer) clearTimeout(stockTimer);
      if (STOCK_MS > 0) {
        stockTimer = setTimeout(function () {
          stockNote.classList.remove('is-in');
          stockFadeTimer = setTimeout(function () { stockNote.hidden = true; }, 320);
        }, STOCK_MS);
      }
    }

    function renderColors() {
      if (!colors.length || !colorsWrap) return;
      colorsWrap.innerHTML = '';
      colors.forEach(function (c) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'tmatrix__color' + (c === selectedColor ? ' is-active' : '');
        var sw = swatchColor(c);
        if (sw) b.style.setProperty('--sw', sw);
        b.appendChild(teeIcon());
        var lbl = document.createElement('span');
        lbl.className = 'tmatrix__cn';
        lbl.textContent = c;
        b.appendChild(lbl);
        b.addEventListener('click', function () {
          selectedColor = c;
          renderColors();
          renderGrid();
          swapForColor(c);
          showStockNote(colorsWrap.closest('.tmatrix__field') || colorsWrap, c);
        });
        colorsWrap.appendChild(b);
      });
      if (colorNameEl) colorNameEl.textContent = selectedColor || '';
    }

    function renderGrid() {
      grid.innerHTML = '';
      sizes.forEach(function (sz) {
        var v = findVariant(selectedColor, sz);
        var avail = v && v.a;
        var cell = document.createElement('label');
        cell.className = 'tmatrix__cell' + (avail ? '' : ' is-disabled');

        var span = document.createElement('span');
        span.className = 'tmatrix__size';
        span.textContent = sz;

        var inp = document.createElement('input');
        inp.type = 'number';
        inp.min = '0';
        inp.inputMode = 'numeric';
        inp.className = 'tmatrix__qty';
        if (avail) {
          inp.value = '0';
          inp.setAttribute('data-variant', v.id);
          inp.setAttribute('data-size', sz);
          inp.addEventListener('input', updateTotal);
          inp.addEventListener('focus', function () { if (inp.value === '0') inp.select(); });
        } else {
          inp.value = '';
          inp.placeholder = '—';
          inp.disabled = true;
        }

        cell.appendChild(span);
        cell.appendChild(inp);
        grid.appendChild(cell);
      });
      updateTotal();
    }

    function collect() {
      var items = [];
      var inputs = grid.querySelectorAll('.tmatrix__qty');
      for (var i = 0; i < inputs.length; i++) {
        var q = parseInt(inputs[i].value, 10) || 0;
        var id = inputs[i].getAttribute('data-variant');
        if (q > 0 && id) items.push({ id: id, quantity: q, size: inputs[i].getAttribute('data-size') });
      }
      return items;
    }

    function updateTotal() {
      var items = collect();
      var t = 0;
      for (var i = 0; i < items.length; i++) t += items[i].quantity;
      if (totalEl) totalEl.textContent = t;
      if (btnCart) btnCart.disabled = t === 0;
      /* Teklif butonu HER ZAMAN aktif kalir. Sonuk buton musteride "burasi kapali /
       * bozuk" izlenimi birakiyordu. Adet secilmeden basilirsa engellemek yerine
       * butonun hemen altinda ipucu gosteriyoruz (asagidaki click handler). */
      if (btnTeklif) btnTeklif.disabled = false;
      hideMsg();
    }

    /* kind: true/'ok' = basarili, 'hint' = nazik yonlendirme, digeri = hata.
     * 'hint' hata degil; kirmizi yerine notr/sari tonda gosterilir. */
    function showMsg(text, kind) {
      if (!msgEl) return;
      msgEl.textContent = text;
      msgEl.hidden = false;
      var cls = (kind === true || kind === 'ok') ? 'is-ok' : (kind === 'hint' ? 'is-hint' : 'is-err');
      msgEl.className = 'tmatrix__msg ' + cls;
    }
    function hideMsg() { if (msgEl) msgEl.hidden = true; }

    function setLoading(btn, on, loadingText) {
      var label = btn.querySelector('.tmatrix__btn-label') || btn;
      if (on) {
        btn.setAttribute('data-prev', label.textContent);
        label.textContent = loadingText;
        btn.disabled = true;
      } else {
        if (btn.getAttribute('data-prev')) label.textContent = btn.getAttribute('data-prev');
      }
    }

    if (btnCart) btnCart.addEventListener('click', function () {
      var items = collect();
      if (!items.length) return;
      setLoading(btnCart, true, 'Ekleniyor…');
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items.map(function (i) { return { id: i.id, quantity: i.quantity }; }) })
      })
        .then(function (r) { if (!r.ok) return r.json().then(function (e) { throw e; }); return r.json(); })
        .then(function () {
          if (cartBehavior === 'stay') {
            setLoading(btnCart, false);
            showMsg('Sepete eklendi ✓', true);
            document.dispatchEvent(new CustomEvent('cart:refresh'));
            updateTotal();
          } else {
            window.location.href = '/cart';
          }
        })
        .catch(function (err) {
          setLoading(btnCart, false);
          btnCart.disabled = false;
          showMsg((err && err.description) || 'Sepete eklenirken sorun oluştu. Tekrar dene.', false);
        });
    });

    if (btnTeklif) btnTeklif.addEventListener('click', function () {
      var items = collect();
      if (!items.length) {
        /* Buton artik aktif oldugu icin bos tiklama BURADA yakalanir:
         * sessizce hicbir sey yapmak yerine ne yapilmasi gerektigini soyluyoruz. */
        showMsg('Önce beden karşısındaki kutuya adet yaz.', 'hint');
        if (grid && grid.scrollIntoView) grid.scrollIntoView({ block: 'center', behavior: 'smooth' });
        var firstQty = grid && grid.querySelector('.tmatrix__qty:not([disabled])');
        if (firstQty && firstQty.focus) firstQty.focus({ preventScroll: true });
        return;
      }
      if (!window.TeklifCart) { showMsg('Teklif sepeti yüklenemedi. Sayfayı yenile.', false); return; }
      items.forEach(function (i) {
        var v = findVariant(selectedColor, i.size);
        var vt = [selectedColor, i.size].filter(Boolean).join(' / ');
        window.TeklifCart.add({
          variantId: String(i.id),
          productId: product.id,
          title: product.title,
          url: product.url,
          variantTitle: vt,
          image: (v && v.img) || '',
          price: (v && typeof v.p === 'number') ? v.p : 0,
          qty: i.quantity
        });
      });
      var inputs = grid.querySelectorAll('.tmatrix__qty');
      for (var k = 0; k < inputs.length; k++) { if (!inputs[k].disabled) inputs[k].value = '0'; }
      updateTotal();
      showMsg('Teklif listene eklendi ✓', true);
      if (window.TeklifCart && window.TeklifCart.openDrawer) window.TeklifCart.openDrawer();
    });

    /* Native varyant secicide RENK varsa: matrisin kendi renk satirini GIZLE,
     * secili rengi oradan oku. Boylece ayni secim iki yerde durmaz. */
    var nativeFs = nativeColorFieldset();
    if (nativeFs && colorsWrap) {
      var ownField = colorsWrap.closest ? colorsWrap.closest('.tmatrix__field') : null;
      if (ownField) ownField.hidden = true;

      var readNative = function () {
        var c = nativeFs.querySelector('input[type="radio"]:checked');
        return c ? c.value : selectedColor;
      };
      selectedColor = readNative() || selectedColor;
      /* Radyo degisiminde ANINDA baslat — temanin render'ini beklemiyoruz. */
      nativeFs.addEventListener('change', function () {
        selectedColor = readNative();
        renderGrid();
        swapForColor(selectedColor);
        showStockNote(nativeFs, selectedColor);
      });
      /* Tema varyanti sunucudan yeniden render edebilir -> secici yenilenir */
      var lastColor = selectedColor;
      document.addEventListener('variant:update', function () {
        var fresh = nativeColorFieldset();
        if (fresh) {
          nativeFs = fresh;
          decorateNativeColors(fresh);
          /* Tema secicinin DOM'unu yeniledi: notu taze fieldset'in yanina geri tak,
           * yoksa gosterilmis olsa bile ekrandan silinmis olur. */
          if (stockShown && !stockNote.hidden) placeStockNote(fresh);
        }
        selectedColor = readNative();
        renderGrid();
        /* Renk degistiyse: o renge ait gorselli varyanttan galeriyi tazele.
         * (Secili varyanta dokunulmaz; yalnizca <media-gallery> yenilenir.) */
        /* KRITIK SIRALAMA: bu olay once BOLUME (temanin media-gallery bileseni),
         * sonra document'e ulasir. Yani tema galeriyi biz yerlestirdikten SONRA
         * kendi (gorselsiz) haliyle EZIYOR. Burada onbellekten aninda geri koyuyoruz —
         * ag istegi olmadigi icin ayni karede gerceklesir, goz fark etmez. */
        lastColor = selectedColor;
        swapForColor(selectedColor, true);
        stockAsk(selectedColor);
      });
      renderGrid();
    } else {
      renderColors();
      renderGrid();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
})();
